export const DESTINATION_TABLE_COLUMN_FIELD = {
  2: [
    // daily_brand_performance
    { id: 1, title: "activity_date" },
    { id: 2, title: "registrations" },
    { id: 3, title: "ftd" },
    { id: 4, title: "qftd" },
    { id: 5, title: "cpa_income" },
    { id: 6, title: "revshare_income" },
    { id: 7, title: "total_income" },
    { id: 8, title: "net_revenue" },
    { id: 9, title: "number_of_deposits" },
    { id: 10, title: "deposit_amount" },
    { id: 11, title: "number_of_cash_bets" },
    { id: 12, title: "sum_of_cash_bets" },
    { id: 13, title: "backend_brand_name" },
    { id: 14, title: "deal_plan_name" },
  ],
  4: [
    // daily_user_performance
    { id: 1, title: "activity_date" },
    { id: 2, title: "user_unique_id" },
    { id: 3, title: "registrations" },
    { id: 4, title: "ftd" },
    { id: 5, title: "qftd" },
    { id: 6, title: "cpa_income" },
    { id: 7, title: "revshare_income" },
    { id: 8, title: "total_income" },
    { id: 9, title: "net_revenue" },
    { id: 10, title: "number_of_deposits" },
    { id: 11, title: "deposit_amount" },
    { id: 12, title: "number_of_cash_bets" },
    { id: 13, title: "sum_of_cash_bets" },
    { id: 14, title: "turnover" },
    { id: 15, title: "wins_sum" },
    { id: 16, title: "commission_type" },
    { id: 17, title: "backend_player_account" },
    { id: 18, title: "backend_campaign_id" },
    { id: 19, title: "backend_campaign_name" },
    { id: 20, title: "backend_brand_name" },
    { id: 21, title: "deal_plan_name" },
  ],
  5: [
    // daily_events_user_performance (newly added)
    { id: 1, title: "activity_date" },
    { id: 2, title: "user_unique_id" },
    { id: 3, title: "registrations" },
    { id: 4, title: "num_of_acquisitions" },
    { id: 5, title: "acquisitions_income" },
    { id: 6, title: "revenue_share_income" },
    { id: 7, title: "brand_revenue" },
    { id: 8, title: "brand_customer_id" },
    { id: 9, title: "promotion_program_id" },
    { id: 10, title: "promo_code" },
    { id: 11, title: "event_id" },
    { id: 12, title: "event_name" },
    { id: 13, title: "event_currency" },
  ],
  1: [
    // monthly_brand_performance
    { id: 1, title: "activity_date" },
    { id: 2, title: "registrations" },
    { id: 3, title: "ftd" },
    { id: 4, title: "qftd" },
    { id: 5, title: "cpa_income" },
    { id: 6, title: "revshare_income" },
    { id: 7, title: "total_income" },
    { id: 8, title: "net_revenue" },
    { id: 9, title: "deal_plan_name" },
  ],
};

// Columns that must always be mapped, per destination table id.
// These stay ticked and their checkbox is disabled, so the user cannot remove them.
export const MANDATORY_DESTINATION_COLUMNS: Record<number, string[]> = {
  // daily_events_user_performance
  5: ["user_unique_id", "event_id", "activity_date"],
};
